// EtTrinityTimeSensePanel.jsx

import { useEffect, useState } from "react";

const getCurrentTimeSegment = () => {
  const now = new Date();
  const hours = now.getHours();

  if (hours >= 0 && hours < 6) return "early_morning";
  if (hours >= 6 && hours < 12) return "morning";
  if (hours >= 12 && hours < 18) return "mid_day";
  if (hours >= 18 && hours < 21) return "evening";
  return "night";
};

const EtTrinityTimeSensePanel = ({ onSegmentDetect }) => {
  // First Created - 19 May 2025
  // Author - Atul Pandey
  // Purpose - To help Trinity sense user's current timeSegment of the day

  // 1 - State Variables
  const [timeSegment, setTimeSegment] = useState("");

  // 2 - Refresh on change
  useEffect(() => {
    const segment = getCurrentTimeSegment();
    setTimeSegment(segment);
    if (onSegmentDetect) {
      onSegmentDetect(segment); // send to parent
    }
  }, []);

  return null; // this is a headless component, no visual output
};

export default EtTrinityTimeSensePanel;